// import "./profileSetting.css";
// import React, { useState, useEffect, Suspense, lazy } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { setHeaderText } from "../../../features/headerText/headerTextSlice";
// import userCategory from "../../../constants/userCategory";

// // Lazy-loaded components
// const UserProfile = lazy(() => import("../../../components/User/UserDetails/UserProfile/UserProfile"));
// const UserAccount = lazy(() => import("../../../components/User/UserDetails/UserAccount/UserAccount"));
// const UserSecurity = lazy(() => import("../../../components/User/UserDetails/UserSecurity/UserSecurity"));
// const UserNotification = lazy(() => import("../../../components/User/UserDetails/UserNotification/UserNotification"));
// const Subscription = lazy(() => import("../../../pages/subscription/subscriptionOverview"));
// const UserNotificationCenter = lazy(() => import("../../../components/User/UserDetails/UserNotificationCenter/UserNotificationCenter"));
// const VendorUserProfile = lazy(() => import("../../../components/Vendors/VendorUserProfile/VendorUserProfile"));
// const ClientUserProfile = lazy(() => import("../../../components/Clients/ClientUserProfile/ClientUserProfile"));
// const CalenderPreference = lazy(() => import("../../../components/User/UserDetails/UserNotification/CalenderPreference"));

// function ProfileSettings() {
//   const dispatch = useDispatch();
//   const [activeTab, setActiveTab] = useState(0);
//   const user = useSelector((state) => state.auth.user);
//   const id = user._id;
//   const venId = user.venId;
//   const cliId = user.cliId;

//   const handleTabClick = (index) => {
//     setActiveTab(index);
//     localStorage.setItem('activeTab', String(index));
//   };

//   useEffect(() => {
//     const storedActiveTab = localStorage.getItem('activeTab');
//     setTimeout(() => {
//       if (storedActiveTab) {
//         setActiveTab(Number(storedActiveTab));
//       }
//       dispatch(setHeaderText("Profile Settings"));
//     }, 0);
//   }, [id, dispatch]);

//   return (
//     <div>
//       <div className='tab-outer-tab-account'>
//         <ul className="tabs">
//           <li className={activeTab === 0 ? 'active-tab' : ''} onClick={() => handleTabClick(0)}>Profile</li>
//           {(user && user.userCategory !== userCategory.Client) && (
//             <li className={activeTab === 1 ? 'active-tab' : ''} onClick={() => handleTabClick(1)}>Bank Accounts</li>
//           )}
//           <li className={activeTab === 2 ? 'active-tab' : ''} onClick={() => handleTabClick(2)}>Security</li>
//           <li className={activeTab === 3 ? 'active-tab' : ''} onClick={() => handleTabClick(3)}>Preferences</li>
//           <li className={activeTab === 6 ? 'active-tab' : ''} onClick={() => handleTabClick(6)}>Calendar Preferences</li>
//           {window.location.hostname !== "wx-agency.talenton.app" && (
//             <li className={activeTab === 5 ? 'active-tab' : ''} onClick={() => handleTabClick(5)}>Subscription</li>
//           )}
//           {(user && user.userCategory !== userCategory.Client) && (
//             <li className={activeTab === 4 ? 'active-tab' : ''} onClick={() => handleTabClick(4)}>Notification Center</li>
//           )}
//         </ul>

//         {/* Suspense wrapper for lazy-loaded tab content */}
//         <Suspense fallback={<div className="loading">Loading...</div>}>
//           <div className="tabs-content account-settings-tab">
//             {activeTab === 0 && (
//               <div className='company-profile'>
//                 {user.userCategory === userCategory.Vendor ? (
//                   <VendorUserProfile id={venId} />
//                 ) : user.userCategory === userCategory.Client ? (
//                   <ClientUserProfile id={cliId} />
//                 ) : (
//                   <UserProfile id={id} />
//                 )}
//               </div>
//             )}

//             {activeTab === 1 && user.userCategory !== userCategory.Client && (
//               <div>
//                 <UserAccount id={id} />
//               </div>
//             )}

//             {activeTab === 2 && (
//               <div className="user-security">
//                 <UserSecurity id={id} />
//               </div>
//             )}

//             {activeTab === 3 && (
//               <div className="prferences">
//                 <UserNotification id={id} />
//               </div>
//             )}

//             {activeTab === 5 && window.location.hostname !== "wx-agency.talenton.app" && (
//               <div className="subscription">
//                 <Subscription id={id} />
//               </div>
//             )}

//             {activeTab === 6 && (
//               <div className="prferences">
//                 <CalenderPreference id={id} />
//               </div>
//             )}

//             {activeTab === 4 && user.userCategory !== userCategory.Client && (
//               <div className="prferences">
//                 <UserNotificationCenter id={id} />
//               </div>
//             )}
//           </div>
//         </Suspense>
//       </div>
//     </div>
//   );
// }

// export default ProfileSettings;

import "./profileSetting.css";
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setHeaderText } from "../../../features/headerText/headerTextSlice";
import userCategory from "../../../constants/userCategory";

// Regular (non-lazy) imports
import UserProfile from "../../../components/User/UserDetails/UserProfile/UserProfile";
import UserAccount from "../../../components/User/UserDetails/UserAccount/UserAccount";
import UserSecurity from "../../../components/User/UserDetails/UserSecurity/UserSecurity";
import UserNotification from "../../../components/User/UserDetails/UserNotification/UserNotification";
import Subscription from "../../../pages/subscription/subscriptionOverview";
import UserNotificationCenter from "../../../components/User/UserDetails/UserNotificationCenter/UserNotificationCenter";
import VendorUserProfile from "../../../components/Vendors/VendorUserProfile/VendorUserProfile";
import ClientUserProfile from "../../../components/Clients/ClientUserProfile/ClientUserProfile";
// import CalenderPreference from "../../../components/User/UserDetails/UserNotification/CalenderPreference";

function ProfileSettings() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const user = useSelector((state) => state.auth.user);
  const id = user?._id;
  const venId = user?.venId;
  const cliId = user?.cliId;

  const handleTabClick = (index) => {
    setActiveTab(index);
    localStorage.setItem('activeTab', String(index));
  };

  useEffect(() => {
    const storedActiveTab = localStorage.getItem('activeTab');
    if (storedActiveTab) {
      setActiveTab(Number(storedActiveTab));
    }
    dispatch(setHeaderText("Profile Settings"));
  }, [id, dispatch]);

  return (
    <div>
      <div className='tab-outer-tab-account'>
        <ul className="tabs">
          <li className={activeTab === 0 ? 'active-tab' : ''} onClick={() => handleTabClick(0)}>Profile</li>
          {(user && user.userCategory !== userCategory.Client) && (
            <li className={activeTab === 1 ? 'active-tab' : ''} onClick={() => handleTabClick(1)}>Bank Accounts</li>
          )}
          <li className={activeTab === 2 ? 'active-tab' : ''} onClick={() => handleTabClick(2)}>Security</li>
          <li className={activeTab === 3 ? 'active-tab' : ''} onClick={() => handleTabClick(3)}>Preferences</li>
          {/* <li className={activeTab === 6 ? 'active-tab' : ''} onClick={() => handleTabClick(6)}>Calendar Preferences</li> */}
          {window.location.hostname !== "wx-agency.talenton.app" && (
            <li className={activeTab === 5 ? 'active-tab' : ''} onClick={() => handleTabClick(5)}>Subscription</li>
          )}
          {(user && user.userCategory !== userCategory.Client) && (
            <li className={activeTab === 4 ? 'active-tab' : ''} onClick={() => handleTabClick(4)}>Notification Center</li>
          )}
        </ul>

        {/* Render tab content directly */}
        <div className="tabs-content account-settings-tab">
          {activeTab === 0 && (
            <div className='company-profile'>
              {user.userCategory === userCategory.Vendor ? (
                <VendorUserProfile id={venId} />
              ) : user.userCategory === userCategory.Client ? (
                <ClientUserProfile id={cliId} />
              ) : (
                <UserProfile id={id} />
              )}
            </div>
          )}

          {activeTab === 1 && user.userCategory !== userCategory.Client && (
            <div><UserAccount id={id} /></div>
          )}

          {activeTab === 2 && (
            <div className="user-security"><UserSecurity id={id} /></div>
          )}

          {activeTab === 3 && (
            <div className="prferences"><UserNotification id={id} /></div>
          )}

          {activeTab === 5 && window.location.hostname !== "wx-agency.talenton.app" && (
            <div className="subscription"><Subscription id={id} /></div>
          )}

          {/* {activeTab === 6 && (
            <div className="prferences"><CalenderPreference id={id} /></div>
          )} */}

          {activeTab === 4 && user.userCategory !== userCategory.Client && (
            <div className="prferences"><UserNotificationCenter id={id} /></div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProfileSettings;